var _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "icon-telegram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.237 10.888C9.07 8.63 12.291 7.14 13.903 6.422c4.603-2.053 5.56-2.41 6.183-2.422.137-.002.444.034.642.207.168.146.214.343.236.481.022.139.05.454.028.7-.25 2.811-1.329 9.633-1.878 12.781-.232 1.333-.69 1.78-1.133 1.823-.962.095-1.693-.682-2.625-1.338-1.459-1.025-2.283-1.664-3.7-2.665-1.636-1.156-.575-1.792.358-2.831.244-.272 4.485-4.41 4.567-4.785.01-.047.02-.222-.077-.314s-.24-.06-.343-.036c-.147.036-2.477 1.688-6.992 4.957-.661.487-1.26.724-1.797.712-.592-.014-1.73-.359-2.577-.654-1.038-.362-1.862-.553-1.79-1.168.037-.32.448-.647 1.232-.982Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons);
export default __webpack_public_path__ + "static/media/icons.5e0415282e5c7400f07ea0189d5da1f6.svg";
export { ForwardRef as ReactComponent };